import React from 'react'

import axios from 'axios'
import { bool, number, object, oneOfType, string } from 'prop-types'

import EditWithAiAction from 'Pods/Profile/Purchases/Shared/EditWithAiAction/EditWithAiAction'
import ContactModalButton from 'Pods/Shared/ContactModalButton'
import Icon from 'Pods/Shared/Icon/Icon'


function FollowButton({
  isFollower, followUrl, unfollowUrl, icon,
}) {
  const handleFollow = (e) => {
    e.preventDefault()

    const { method, href } = e.target.dataset
    axios({ method, url: href })
      .then(() => window.location.reload())
      .catch((err) => console.error(err))
  }
  if (isFollower) {
    return (
      <button
        data-method="delete"
        data-href={unfollowUrl}
        title="Unfollow"
        className="button"
        onClick={(e => handleFollow(e))}
      >
        {icon}
        Unfollow
      </button>
    )
  }

  return (
    <button
      data-method="post"
      data-href={followUrl}
      title="Follow"
      className="button"
      onClick={(e => handleFollow(e))}
    >
      {icon}
      Follow
    </button>
  )
}

function ProductActions({
  isPaid = false,
  isPending = false,
  isFailed = false,
  contactProps,
  invoicePath,
  isDownloadable = false,
  isModel = false,
  isCollection = false,
  modelDownloadData,
  collectionDownloadData,
  unityDownloadLink,
  fbxDownloadLink,
  followUrl,
  unfollowUrl,
  isFollower,
  isYahaha = false,
  itemId = null,
  editWithAiEnabled = false,
}) {
  if (isPending) {
    return (
      <small>Payment is under review</small>
    )
  }

  if (isFailed) {
    return (
      <small>Payment Failed</small>
    )
  }

  const currentDataSet = isModel ? modelDownloadData : collectionDownloadData
  const yahahaDownloadLink = unityDownloadLink || fbxDownloadLink
  const downloadLinkType = unityDownloadLink ? 'Unity' : 'Fbx'

  if (isPaid) {
    return (
      <div className="actions-row">
        {isDownloadable && (isModel || isCollection) && isYahaha && (
          <a href={yahahaDownloadLink} data-method="post">
            {`${downloadLinkType} download`}
          </a>
        )}
        {(isDownloadable && (isModel || isCollection)) && (
          <button
            data-href={currentDataSet.href}
            data-toggle={currentDataSet.toggle}
            data-target={currentDataSet.target}
            title="Download files"
            className="button button--alt js-download"
          >
            <Icon type={['fas', 'cloud-download']} />
            Download
          </button>
        )}
        {contactProps && (
          <span>
            <ContactModalButton {...contactProps} />
          </span>
        )}
        {invoicePath && (
          <a className="button button--dark" href={invoicePath}>
            Invoice
          </a>
        )}
        <FollowButton
          isFollower={isFollower}
          followUrl={followUrl}
          unfollowUrl={unfollowUrl}
          icon={<Icon type={['fas', 'user-plus']} />}
        />
        {editWithAiEnabled && isDownloadable && isModel && itemId && (
          <EditWithAiAction itemId={itemId} />
        )}
      </div>
    )
  }

  return (
    <small>Unpaid</small>
  )
}

ProductActions.propTypes = {
  isPaid: bool.isRequired,
  isPending: bool.isRequired,
  isFailed: bool.isRequired,
  contactProps: object,
  invoicePath: string,
  isDownloadable: bool.isRequired,
  isModel: bool.isRequired,
  isCollection: bool.isRequired,
  modelDownloadData: object.isRequired,
  collectionDownloadData: object.isRequired,
  isYahaha: bool,
  unityDownloadLink: string,
  fbxDownloadLink: string,
  followUrl: string,
  unfollowUrl: string,
  isFollower: bool,
  itemId: oneOfType([number, string]),
  editWithAiEnabled: bool,
}

export default ProductActions
